
import React, { Component } from "react";


class FormTextRow extends Component {

    state = {
        editing: false
    }

    editingStart = () => {
        this.setState({
            editing: true
        })
    }

    editingEnd = ()=> {
        this.setState({
            editing: false
        })
    }

    render(){

        const {value,name,type} = this.props;

        return <div className="formRow" onMouseOver={this.editingStart} onMouseLeave={this.editingEnd}>
        <label name={name}>
            {this.props.label || name} 
            {this.props.error ? <span className="error">{this.props.error}</span> : ''}
        </label>
        <div className="formRow-content">
            <input onChange={this.props.onChange} name={name} type={type || "text"} value={value || ''}/>
            <button className={this.state.editing ? "" : "buttonHidden"} onClick={() => {this.props.onEmptyField(name)}}>
                <i className="ion-close-circled"></i>
            </button>
        </div>
    </div>
    }
}

export default FormTextRow;